import FeatureContainer from "../../../Layout/Containers/FeatureContainer";
import ModalUpdateShift from "../components/ModalUpdateShift";
import { useContext, useEffect, useState } from "react";
import useAxios from "../../../Utils/useAxios";
import ShiftListBulanan from "../components/ShiftListBulanan";
import ModalGetTemplate from "../components/ModalGetTemplate";
import PreviewShift from "../components/PreviewShift";
import getShiftByMonth from "../services/getShiftByMonth";
import { PERMISSIONS } from "../../../Constant/FeatureSelection";
import RoleContext from "../../../Context/RoleContext";

const ShiftContainer = () => {
  const { checkPermission } = useContext(RoleContext);
  const [data, setData] = useState([]);
  const [shift, setShift] = useState({
    data: [],
    berkas: "",
  });
  const [mode, setMode] = useState("list");
  const [pending, setPending] = useState(false);
  const axiosInstance = useAxios();

  const [monthFilter, setMonthFilter] = useState(
    `${new Date().getFullYear()}-${(new Date().getMonth() + 1)
      .toString()
      .padStart(2, "0")}`
  );

  let isMounted = true;
  useEffect(() => {
    const fetchData = async () => {
      refreshShift();
    };

    if (isMounted) fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    refreshShift();
  }, [monthFilter]);

  const refreshShift = () => {
    getShiftByMonth(axiosInstance, monthFilter).then((res) => {
      setData(res.data);
      setPending(false);
    });
  };

  const updateMonthFilter = (newYear) => setMonthFilter(newYear);

  const button = mode === "list" && (
    <div>
      <ModalUpdateShift setShift={setShift} setMode={setMode} />
      <ModalGetTemplate />
    </div>
  );

  return (
    <FeatureContainer title={"Shift"} createButton={checkPermission(PERMISSIONS.ADD_SHIFT) && button}>
      {mode === "list" && (
        <ShiftListBulanan
          data={data}
          updateMonthFilter={updateMonthFilter}
          pending={pending}
          monthFilter={monthFilter}
        />
      )}
      {mode === "preview" && (
        <PreviewShift
          setMode={setMode}
          resetState={refreshShift}
          shift={shift}
        />
      )}
    </FeatureContainer>
  );
};

export default ShiftContainer;
